import {EActionType, EActiveCondition} from './types';

export const ACTIVE_CONDITION_SELECT_OPTIONS = [
    {
        value: EActiveCondition.ALWAYS,
        label: 'Действие применимо для всех строк без выделения чек-боксом',
    },
    {
        value: EActiveCondition.ONE_ROW_ONLY,
        label: 'Действие применимо после выделения только одной строки чек-боксом',
    },
    {
        value: EActiveCondition.ANY_ROWS,
        label: 'Действие применимо после выделения одной и более строки чек-боксом',
    },
];

export const ACTION_TYPE_SELECT_OPTIONS = [
    {
        value: EActionType.BUTTON,
        label: 'Нажатие на кнопку пользователем',
    },
    {
        value: EActionType.UPLOAD_FILE,
        label: 'Прикрепление файла пользователем',
    },
];
